import { UserStatus } from 'src/@types/user-status';
import { UserRecent } from 'src/hooks/recents';
import { addListener } from '../common';

export const onUserStatusUpdate = addListener<{
  userId: string;
  status: UserStatus;
}>('/user/status');

export const onUserRecentsUpsert = addListener<UserRecent>('/user-recents/new');

export const onUserRecentsDelete = addListener<string>('/user-recents/delete');

export const onUserRefresh = addListener<{ refresh: true }>('/user/refresh');
